module.exports = __webpack_public_path__ + "img/set-for-life-circle.97d8bb02.jpeg";